import { useMemo } from "react";
import { useScheduleContext } from "../context/useScheduleContext";

// The job/location/level of the grouped row the shift is in; the form keeps it and locks the field
export const useRowGroupBy = (): { field: string; value: any } | undefined => {
    const { selectedCellOrEvent, allResources } = useScheduleContext();

    return useMemo(() => {
        const row = allResources?.find((resource: any) => resource?.id === selectedCellOrEvent?.resourceId);
        const groupBy = row?.groupBy ?? (selectedCellOrEvent?.user as any)?.groupBy;
        return groupBy?.value ? groupBy : undefined;
    }, [allResources, selectedCellOrEvent?.resourceId, selectedCellOrEvent?.user]);
};
